import React, { Component } from "react";
import u_1 from "../../QRMenu/feedback-emojis/u_1.png";
import u_2 from "../../QRMenu/feedback-emojis/u_2.png";
import u_3 from "../../QRMenu/feedback-emojis/u_3.png";
import u_4 from "../../QRMenu/feedback-emojis/u_4.png";
import u_5 from "../../QRMenu/feedback-emojis/u_5.png";
import one from "../../QRMenu/feedback-emojis/1.png";
import two from "../../QRMenu/feedback-emojis/2.png";
import three from "../../QRMenu/feedback-emojis/3.png";
import four from "../../QRMenu/feedback-emojis/4.png";
import five from "../../QRMenu/feedback-emojis/5.png";
import Logo from "../Images/hospital.png";
import { apiEndpoint, mainWebsite } from "./../../../../Utils/endpoints";
import axios from "axios";
import Swal from "sweetalert2";

class CustomerFeedback extends Component {
  state = { rating: null, remarks: null };
  rate = (id) => {
    this.setState({ rating: id });
  };
  render() {
    return (
      <div class="content">
        <div className="row">
          <div className="col-12 pt-5">
            <div className="text-center">
              <img
                src={Logo}
                className="img-fluid"
                style={{ height: "120px" }}
              />
            </div>
          </div>
        </div>
        <div
          class="jumbotron text-center pt-5"
          style={{
            backgroundColor: "none !important",
          }}
        >
          <h5 class=" mb-0" style={{ fontWeight: "300", fontSize: "30px" }}>
            How was our service?
          </h5>
          <div style={{ textAlign: "center" }}>
            <div className="row mb-2 mt-4">
              <img
                style={{ cursor: "pointer" }}
                src={this.state.rating === 1 ? one : u_1}
                className=" col-2 col-md-2 col-sm-2 m-auto"
                onClick={() => this.rate(1)}
              />
              <img
                style={{ cursor: "pointer" }}
                src={this.state.rating === 2 ? two : u_2}
                className=" col-2 col-md-2 col-sm-2 m-auto"
                onClick={() => this.rate(2)}
              />
              <img
                style={{ cursor: "pointer" }}
                src={this.state.rating === 3 ? three : u_3}
                className=" col-2 col-md-2 col-sm-2 m-auto"
                onClick={() => this.rate(3)}
              />
              <img
                style={{ cursor: "pointer" }}
                src={this.state.rating === 4 ? four : u_4}
                className=" col-2 col-md-2 col-sm-2 m-auto"
                onClick={() => this.rate(4)}
              />
              <img
                style={{ cursor: "pointer" }}
                src={this.state.rating === 5 ? five : u_5}
                className=" col-2 col-md-2 col-sm-2 m-auto"
                onClick={() => this.rate(5)}
              />
            </div>
            <div className="mt-4">
              <textarea
                className="col-md-6 form-control m-auto mb-2"
                rows="4"
                id="remarks"
              />
            </div>
            <div className="mt-2">
              {" "}
              <button
                className="col-md-6 form-control m-auto pt-1"
                style={{ color: "white", backgroundColor: "#c92127" }}
                type="button"
                onClick={this.sendFeedback}
              >
                Send Feedback
              </button>
              <br />
              <button
                className="col-md-6 form-control m-auto pt-1 btn btn-warning"
                type="button"
                onClick={() => this.props.history.push("/checking-status")}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  sendFeedback = async () => {
    let rating = this.state.rating;
    let remarks = document.getElementById("remarks").value;
    let ticket = this.props.ticket;
    if (remarks === "" || remarks === undefined) {
      remarks = null;
    }
    const token = sessionStorage.getItem("scanner_token");
    const response = await axios.post(
      apiEndpoint + "corporate/customer/feedback",
      {
        remarks: remarks,
        rating: rating,
        ticket_id: this.props.match.params.ticket_id,
      },
      { headers: { Authorization: token } }
    );
    if (response.data.status === 200) {
      Swal.fire({
        title: "Feedback Sent",
        icon: "success",
        text: "Thank you for valuable feedback!",
        showConfirmButton: false,
      });
      // sessionStorage.removeItem("current_ticket");
      // sessionStorage.removeItem("user_token");
      setTimeout(() => {
        Swal.close();
        // sessionStorage.clear();
        //   window.location.href = `${corporateEndpoint}/takeaway/user-detail/${this.props.id}`;
        this.props.history.push("/checking-status");
      }, 3000);
    } else {
      Swal.fire({
        title: response.data.message,
        icon: "error",
        text: "",
        showConfirmButton: true,
      });
    }
  };
}

export default CustomerFeedback;
